import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './display-request-unavailable.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisplayRequestUnavailableModal {
}
